var React = require('react');

function ButtonShape03 (props) {
    return React.createElement("svg",props,React.createElement("path",{"className":"st4","d":"M153.81,73.71c12.49-2.06,23.41-10.5,23.09-28.46c-0.32-18.28-1.31-36.04-34.66-42.7\n\tC124.63-0.98,64.39-1.16,28.47,9.66C10.8,14.98-1.08,23.32,1.27,42.33C3.58,60.99,7.27,73.08,40.25,76.1\n\tC67.82,78.63,122.31,78.9,153.81,73.71z"}));
}

ButtonShape03.defaultProps = {"viewBox":"0 0 177.89 78.25"};

module.exports = ButtonShape03;

ButtonShape03.default = ButtonShape03;
